module.exports = __webpack_public_path__ + "img/icon-e.861158ac.png";